import "./index.scss";
import React from "react";
import clsx from 'clsx';

const Button = ({ btn, className, onClick, label, disabled }) => {
    if (btn === false) {
        return null;
    }

    const defaultButton = <button type="button" className={clsx('btn m0', className, disabled && 'disabled')} disabled={disabled} data-dismiss="modal" onClick={!disabled ? onClick : undefined}> { label } </button>;

    if (btn === null) {
        return defaultButton
    }

    if (btn.component) {
        return btn.component;
    }
    
    if (btn.link) {
        return <a href={disabled ? '#' : btn.link} className={clsx('btn m0', className, disabled && 'disabled')} data-dismiss="modal" onClick={!disabled ? onClick : undefined} target={btn.target || null}> { label }</a>
    }

    return defaultButton;
}

class ConfirmModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const  {
            id,
            title,
            classes,
            modalWidth = '520px',
            open=true,
            onCancel,
            onConfirm, 
            message = 'Do you wish to proceed?',
            cancelBtn = null,
            confirmBtn = null,
        } = this.props;

        if (!open) {
            return null;
        }

        const body = this.props.children
            ? this.props.children
            :  <div className="text-black m0">{message}</div>
        const cancelButton = <Button
            className='btn-cancel text-black'
            btn={cancelBtn}
            label={(cancelBtn && cancelBtn.label) || 'Cancel'}
            onClick={onCancel}
        />;
        const confirmButton = <Button
            className='btn-confirm'
            btn={confirmBtn}
            label={(confirmBtn && confirmBtn.label) || 'Confirm'}
            onClick={onConfirm}
            disabled={confirmBtn && confirmBtn.disabled}
        />;

        const showFooter = cancelBtn !== false || confirmBtn !== false;

        return (
            <div className={`modal fade discard-changes-modal bg-overlay show in ${classes}`} id={id} style={{ zIndex: 999999 }}>
                <div className="modal-dialog" role="document" style={{ width: modalWidth }}>
                    <div className="modal-content">
                        <div className="modal-header border-none">
                            <div className="headerTitleContainer">
                                <p className="headerTitle">{ title }</p>
                                <a className="closeBtn" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
                                    <i className="material-icons text-black text-size22">close</i>
                                </a>
                            </div>
                        </div>
                        <div className="modal-body bt">
                            { body } 
                        </div>
                        {showFooter && (
                          <div className="modal-footer pt15 pb15">
                              <div className="row">
                                  <div className="col-lg-4 col-md-4 col-sm-4">
                                      { cancelButton }
                                  </div>
                                  <div className="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                      { confirmButton }
                                  </div>
                              </div>
                          </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmModal;
